module.exports = __webpack_public_path__ + "static/media/temka.aa1485f9.png";